import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const TOKEN_KEY = "mb_crm_token";

export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (t) => localStorage.setItem(TOKEN_KEY, t);
export const clearToken = () => localStorage.removeItem(TOKEN_KEY);

const client = axios.create({ baseURL: API });

// Impersonation: staff (admin/super) can act as a student. The selected student's
// id is stored in sessionStorage and sent on every request so the backend scopes
// data to that student. Students have this empty (ignored server-side anyway).
export const ACTING_KEY = "mb_acting";
export const getActing = () => {
  try { return JSON.parse(sessionStorage.getItem(ACTING_KEY) || "null"); } catch (e) { return null; }
};
export const setActing = (s) => {
  if (s) sessionStorage.setItem(ACTING_KEY, JSON.stringify(s));
  else sessionStorage.removeItem(ACTING_KEY);
};

client.interceptors.request.use((config) => {
  const token = getToken();
  if (token) config.headers.Authorization = `Bearer ${token}`;
  const acting = getActing();
  if (acting?.user_id) config.headers["X-Acting-As"] = acting.user_id;
  return config;
});

export default client;
